module.exports = __webpack_public_path__ + "img/google.3ae87f78.png";